import animationData from 'assets/animations/analyzing.json'

export const lottieOptions = {
  loop: false,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}
